module.exports = __webpack_public_path__ + "img/tolet.e333eae7.svg";